import React, {useEffect} from 'react';
import {TextField} from '@bonprix/design-system';
import {Controller, useFormContext} from 'react-hook-form';

export default function RhfTextField({
                                         name,
                                         helperText,
                                         label,
                                         validation,
                                         formatter,
                                         errorText,
                                         onChange,
                                         hideClear = false
                                     }) {

    const {control, clearErrors, setError} = useFormContext();

    useEffect(() => {
        if (errorText) {
            setError(name, {type: 'manual', message: errorText});
        }
    }, [errorText]);

    return (
        <Controller
            name={name}
            control={control}
            rules={validation}
            render={({field, fieldState}) => {
                const handleChange = (value) => {
                    clearErrors(name);
                    let newValue = value;
                    if (formatter) {
                        newValue = formatter(value);
                    }
                    field.onChange(newValue);
                    onChange?.(newValue);
                };

                return <TextField
                    name={name}
                    helperText={helperText}
                    label={label}
                    error={fieldState.invalid}
                    errorText={fieldState.error?.message}
                    hideClear={hideClear}
                    value={field.value}
                    onBlur={field.onBlur}
                    inputRef={field.ref}
                    onChange={handleChange} />;
            }}
        />
    );
}